import { z } from 'zod';

export const OfficeSchema = z.object({
  id_office: z.number().int(),
  value: z.string(),
  description: z.string(),
  id_state: z.union([z.boolean(), z.number().int()]).optional(),
});

export const OfficesApiResponseSchema = z.object({
  status: z.number(),
  message: z.string(),
  data: z.array(OfficeSchema),
});

export type Office = z.infer<typeof OfficeSchema>;
export type OfficesApiResponse = z.infer<typeof OfficesApiResponseSchema>;

export type MappedOffice = Office & {
  idOff: number;
  itemValue: string;
  nameOff: string;
  valueOff: string;
};
